module.exports = __webpack_public_path__ + "images/banner-yunnan.jpg?ba1e1b15963eb1a9d5b77f888b54454e";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-yunnan.jpg
// module id = 176
// module chunks = 1